import { settingsRoutes } from './settingsRoutes';
import { partnersRoutes } from './partnersRoutes';
import { clientsRoutes } from './clientsRoutes';
import { templatesRoutes } from './templatesRoutes';
import { resultRoutes } from './resultRoutes';
import { surveyTrackingRoutes } from './SurveyTrackingRoutes';
import { nexusRoutes } from './nexusRoutes';

export const moduleRoutesList = [
	partnersRoutes,
	clientsRoutes,
	templatesRoutes,
	surveyTrackingRoutes,
	resultRoutes,
	nexusRoutes,
	settingsRoutes,

	// queriesRoutes,
];
